// extracted by mini-css-extract-plugin
module.exports = {"root":"_38b05edd","text":"_52d09e82","button":"_aeefb33e","icon":"_756159ec","collapsibleContent":"_29adb81b","slideDown":"_dff613f0","slideUp":"_eba390bb"};